module.exports = __webpack_public_path__ + "static/media/icon-experiencia.5e62bdb9.svg";